import CommonIriDisplay from '../CommonIriDisplay';
import { Typography } from '@material-ui/core';
import MenuSelector from '../../core/MenuSelector';
import ProjectLink from '../../vocabulary/core/ProjectLink';
import BasicLanguageFieldDisplay from '../../core/BasicLanguageFieldDisplay';
import LiteralConfirmationField from '../../core/LiteralConfirmationField';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import IntegerConfirmationField from '../../core/IntegerConfirmationField';
import TextConfirmationField from '../../core/TextConfirmationField';
import SchemeChip from '../../vocabulary/core/SchemeChip';
import { withStyles } from '@material-ui/core/styles';
import GS from '../../grafsync/grafsync';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';
import FindComponentDialog from './FindComponentDialog';
import { MAX_DESCRIPTION_LENGTH, MAX_TITLE_LENGTH, RANGE_MEDIATYPE_MAPPING, MODULES } from '../../core/utils/constants';
import { globalStyles } from '../../core/style/gstheme';
import { getGraphFromProject, getProjectFromGraph, isModuleActivated } from '../../core/utils/utils';

const styles = () => {
    return Object.assign({
        emptyPanel: {
            border: 'solid 1px #a0a0a0',
            borderRadius: 4,
            marginRight: 6,
            paddingRight: 6,
            paddingTop: 3,
            paddingBottom: 2,
            transform: 'translateY(-2px)'
        },
        filledPanel: {
            transform: 'translateY(-2px)'
        }
    }, globalStyles);
};

class ShaclPropertyPath extends React.Component {

    render() {

        const { data, defaultLang, dataTest, id, propertyShapeData, onSetMaxCount, onUpdate, onDelete, onAddLanguage, modules,
            onSetMinCount, onSetMaxLength, onSetPattern, patternTest, onDeleteValue, classes, handleMediaMappingChange,
            enableProjectSelection, projectGraph, includeSelectFrom,
            onAddComponent, graph, onDeleteLink, project, updatePatternTest, onDeletePattern } = this.props;

        const isReadOnly = this.props.isReadOnly || data.pendingDeletion;

        if (data._notAvailable) {
            return <TableRow
                data-test={dataTest}
                style={{
                    borderBottom: 'solid 1px #ffffff'
                }}>
                <TableCell data-test="prop-link">
                    <CommonIriDisplay
                        dataTest={"deleted-prop-" + id}
                        id={id}
                        projectIRI={getProjectFromGraph(graph)}
                        onDeleteIRI={() => onDeleteLink(propertyShapeData.id)}
                        loadComponents={true}
                        superCompact={true}
                        highlight={true}
                        handleNotAvailable={true}
                        isReadOnly={this.props.isReadOnly}
                        wrap={false}
                        source={id}
                        sourceGraph={projectGraph}
                        graph={graph}
                        property="targetPredicate"
                        viewLang={defaultLang}
                        defaultLang={defaultLang} />
                </TableCell>
            </TableRow>;
        }

        const shPath = propertyShapeData.shPath;
        const isDatatypeProperty = data.type.includes("DatatypeProperty");
        const isAnnotationProperty = data.type.includes("AnnotationProperty");
        const isObjectProperty = data.type.includes("ObjectProperty");
        const isFunctionalProperty = data.type.includes("FunctionalProperty");
        const isComponentRange = data.range && (data.range.includes("http://www.w3.org/2004/02/skos/core#ConceptScheme")
            || data.range.includes("http://www.w3.org/2004/02/skos/core#Collection")
            || data.range.includes("http://www.w3.org/2004/02/skos/core#OrderedCollection"));
        const isBoolean = "range" in data && data.range.includes("http://www.w3.org/2001/XMLSchema#boolean");
        const isString = ("range" in data &&
            (data.range.includes("http://www.w3.org/2001/XMLSchema#string")
                || data.range.includes("http://www.w3.org/2000/01/rdf-schema#Literal")
                || data.range.includes("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString")))
            || ((isDatatypeProperty || isAnnotationProperty) && !("range" in data));
        const mediaMappings = "range" in data && data.range.length === 1 &&
            data.range[0] in RANGE_MEDIATYPE_MAPPING ?
            RANGE_MEDIATYPE_MAPPING[data.range[0]]
            :
            [];
        const isLangString = "range" in data && data.range.includes("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString");
        const treatContentAs = "treatContentAs" in propertyShapeData && propertyShapeData.treatContentAs !== undefined ?
            propertyShapeData.treatContentAs
            :
            "";
        const maxLength = "shMaxLength" in propertyShapeData && propertyShapeData.shMaxLength !== undefined ?
            propertyShapeData.shMaxLength
            :
            '';
        const pattern = "shPattern" in propertyShapeData && propertyShapeData.shPattern !== undefined ?
            propertyShapeData.shPattern
            :
            "";
        const minCount = "shMinCount" in propertyShapeData && propertyShapeData.shMinCount !== undefined ?
            propertyShapeData.shMinCount
            :
            '';
        const maxCount = "shMaxCount" in propertyShapeData && propertyShapeData.shMaxCount !== undefined ?
            propertyShapeData.shMaxCount
            :
            isBoolean || isFunctionalProperty ?
                1
                :
                '';

        return (
            <TableRow
                data-test={dataTest}
                style={{
                    borderBottom: 'solid 1px #ffffff'
                }}>
                <TableCell data-test="prop-link" style={{ paddingLeft: 0 }}>
                    <CommonIriDisplay
                        dataTest={"property-resource-link-" + shPath}
                        key={id}
                        id={id}
                        onDeleteIRI={() => onDeleteLink(propertyShapeData.id)}
                        projectIRI={getProjectFromGraph(graph)}
                        loadComponents={true}
                        checkIfUsedOnDelete={
                            {
                                graph: propertyShapeData.inNamedGraph,
                                predicate: GS.getIRIfromAlias(shPath) || shPath,
                                message: [
                                    "This associated property is used within this project.",
                                    "Removing it from this template will not remove data using it but the data may only be visible in the Triples Viewer.",
                                    "Do you want to proceed with removing this property?"
                                ]
                            }
                        }
                        handleNotAvailable={true}
                        isReadOnly={this.props.isReadOnly}
                        wrap={false}
                        superCompact={true}
                        sourceGraph={projectGraph}
                        graph={graph}
                        viewLang={defaultLang}
                        defaultLang={defaultLang} />
                </TableCell>
                <TableCell style={{
                    paddingLeft: 0,
                    minWidth: propertyShapeData.shName && Object.keys(propertyShapeData.shName).length > 0 ?
                        200
                        :
                        60
                }}>
                    <div className={(propertyShapeData.shName && Object.keys(propertyShapeData.shName).length > 0) || isReadOnly ?
                        classes.filledPanel
                        :
                        classes.emptyPanel
                    }>
                        <BasicLanguageFieldDisplay
                            dataTest="name"
                            ariaLabel="Override name"
                            defaultLang={defaultLang}
                            title={undefined}
                            tooltipText="Add a name"
                            message={"Add a Name"}
                            property="shName"
                            values={propertyShapeData.shName}
                            onePerLang={true}
                            placeholder="Enter name"
                            projectLang={[defaultLang]}
                            required={false}
                            maxLength={MAX_TITLE_LENGTH}
                            onAddLanguage={onAddLanguage}
                            onUpdate={onUpdate}
                            onDelete={onDelete}
                            isReadOnly={isReadOnly} />
                    </div>
                </TableCell>
                <TableCell style={{
                    paddingLeft: 0,
                    minWidth: propertyShapeData.shDescription && Object.keys(propertyShapeData.shDescription).length > 0 ?
                        200
                        :
                        60
                }}>
                    <div className={(propertyShapeData.shDescription && Object.keys(propertyShapeData.shDescription).length > 0) || isReadOnly ?
                        classes.filledPanel
                        :
                        classes.emptyPanel
                    }>
                        <BasicLanguageFieldDisplay
                            ariaLabel="Property description"
                            dataTest="description"
                            defaultLang={defaultLang}
                            title={undefined}
                            tooltipText="Add a description"
                            message={"Add a Description"}
                            property="shDescription"
                            values={propertyShapeData.shDescription}
                            onePerLang={true}
                            placeholder="Enter description"
                            projectLang={[defaultLang]}
                            required={false}
                            maxLength={MAX_DESCRIPTION_LENGTH}
                            onAddLanguage={onAddLanguage}
                            onUpdate={onUpdate}
                            onDelete={onDelete}
                            isReadOnly={isReadOnly} />
                    </div>
                </TableCell>
                <TableCell style={{ paddingLeft: 0 }}>
                    <IntegerConfirmationField
                        ariaLabel="Update minimum count"
                        dataTest={"update-min-count"}
                        margin="dense"
                        text={minCount}
                        minValue={0}
                        maxValue={isBoolean || isFunctionalProperty ? 1 : 1000}
                        onUpdate={onSetMinCount}
                        onDelete={onDeleteValue("shMinCount")}
                        isReadOnly={isReadOnly} />
                </TableCell>
                <TableCell style={{ paddingLeft: 0 }}>
                    <IntegerConfirmationField
                        ariaLabel="Update maximum count"
                        dataTest={"update-max-count"}
                        margin="dense"
                        text={maxCount}
                        minValue={minCount > 0 ? minCount : 1}
                        maxValue={isBoolean || isFunctionalProperty ? 1 : 1000}
                        onUpdate={onSetMaxCount}
                        onDelete={onDeleteValue("shMaxCount")}
                        isReadOnly={isFunctionalProperty || isBoolean || isReadOnly} />
                </TableCell>
                <TableCell style={{ paddingLeft: 0 }}>
                    {isString &&
                        <IntegerConfirmationField
                            ariaLabel="Update maximum length"
                            dataTest={"update-max-length"}
                            margin="dense"
                            text={maxLength}
                            maxValue={1000}
                            onUpdate={onSetMaxLength}
                            onDelete={onDeleteValue("shMaxLength")}
                            isReadOnly={isReadOnly} />
                    }
                </TableCell>
                <TableCell style={{ paddingLeft: 0 }}>
                    {isString && !isLangString &&
                        <div>
                            <TextConfirmationField
                                dataTest={"update-pattern"}
                                ariaLabel="Update pattern"
                                margin="dense"
                                text={pattern}
                                maxLength={250}
                                onUpdate={onSetPattern}
                                onDelete={onDeletePattern}
                                isReadOnly={isReadOnly} />
                            {pattern && <LiteralConfirmationField
                                ariaLabel="Test your pattern"
                                key={pattern}
                                dataTest="pattern-test"
                                margin="dense"
                                pattern={pattern}
                                placeHolder="Test your pattern"
                                allowEmpty={true}
                                maxLength={maxLength || 1000}
                                text={patternTest}
                                canBeDeleted={false}
                                onUpdate={updatePatternTest}
                                isReadOnly={false}
                            />
                            }
                        </div>
                    }
                </TableCell>
                <TableCell style={{
                    paddingLeft: 0,
                    minWidth: 100
                }}>
                    {mediaMappings && mediaMappings.length > 0 && isModuleActivated(modules, MODULES.TREAT_CONTENT_AS) &&
                        <MenuSelector
                            dataTest="media-mapping-selector"
                            selected={treatContentAs && mediaMappings.some(m => m.value === treatContentAs) ?
                                treatContentAs
                                :
                                "none"}
                            disabled={isReadOnly}
                            handleChange={handleMediaMappingChange}
                            options={[
                                {
                                    label: "Non-specific",
                                    value: "none"
                                },
                                ...mediaMappings
                            ]} />}
                    {!isModuleActivated(modules, MODULES.TREAT_CONTENT_AS) &&
                        <Typography data-test="tca-not-avaialble" variant="caption">Not available.</Typography>
                    }
                </TableCell>
                {includeSelectFrom &&
                    <TableCell style={{ paddingLeft: 0 }}>
                        {isObjectProperty && !isComponentRange &&
                            <div>
                                {
                                    !isReadOnly && (!propertyShapeData.inComponent || propertyShapeData.inComponent.length === 0) &&
                                    <div style={{ marginBottom: 12 }}>
                                        <FindComponentDialog
                                            enableProjectSelection={enableProjectSelection}
                                            graph={propertyShapeData.inNamedGraph}
                                            onAddComponent={onAddComponent}
                                            defaultLang={defaultLang}
                                        />
                                    </div>
                                }
                                {propertyShapeData.inComponent && propertyShapeData.inComponent.length > 0 &&
                                    <div style={{ marginTop: 4 }}>
                                        {propertyShapeData.inComponentProject && enableProjectSelection &&
                                            <div style={{ marginBottom: 6 }}>
                                                <ProjectLink
                                                    color="#000000"
                                                    id={propertyShapeData.inComponentProject}
                                                    defaultLang={defaultLang}
                                                    displayNotAvailable={true}
                                                    handleNotAvailable={true}
                                                    graph={propertyShapeData.inComponentProject ?
                                                        getGraphFromProject(propertyShapeData.inComponentProject)
                                                        :
                                                        propertyShapeData.inNamedGraph} />
                                            </div>
                                        }
                                        <SchemeChip
                                            id={propertyShapeData.inComponent[0]}
                                            property="inComponent"
                                            viewLang={defaultLang}
                                            defaultLang={defaultLang}
                                            handleNotAvailable={true}
                                            project={propertyShapeData.inComponentProject || project}
                                            isReadOnly={isReadOnly}
                                            graph={propertyShapeData.inComponentProject ?
                                                getGraphFromProject(propertyShapeData.inComponentProject)
                                                :
                                                propertyShapeData.inNamedGraph}
                                            sourceGraph={propertyShapeData.inNamedGraph}
                                            source={propertyShapeData.id} />
                                    </div>
                                }
                            </div>
                        }
                    </TableCell>
                }
            </TableRow>
        );
    }
}

ShaclPropertyPath.defaultProps = {
    isReadOnly: false,
    enableProjectSelection: false
};

ShaclPropertyPath.propTypes = {
    data: PropTypes.object.isRequired,
    classes: PropTypes.object,
    dataTest: PropTypes.string,
    propertyShapeData: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    project: PropTypes.string.isRequired,
    projectGraph: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    onDeleteLink: PropTypes.func.isRequired,
    onAddComponent: PropTypes.func.isRequired,
    onSetMinCount: PropTypes.func.isRequired,
    onSetMaxCount: PropTypes.func.isRequired,
    onDeleteValue: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onAddLanguage: PropTypes.func,
    patternText: PropTypes.string,
    updatePatternTest: PropTypes.func,
    handleMediaMappingChange: PropTypes.func,
    onDeletePattern: PropTypes.func,
    onSetPattern: PropTypes.func,
    onSetMaxLength: PropTypes.func,
    isReadOnly: PropTypes.bool,
    modules: PropTypes.number,
    includeSelectFrom: PropTypes.bool,
    enableProjectSelection: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired
};

export default withStyles(styles)(withGS(ShaclPropertyPath));